import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card';
export function SecondaryServicesSection() {
  const services = [{
    title: 'Heated Driveways',
    description: 'Never shovel again. Keep your driveway clear of snow and ice automatically.',
    image: 'https://cdn.magicpatterns.com/uploads/n9ApLtYLfM6nzBj9ahVHvB/herov2.png'
  }, {
    title: 'Heated Walkways',
    description: 'Keep your front path and sidewalk clear for mail carriers and guests.',
    image: 'https://cdn.magicpatterns.com/uploads/trfdmHn1oyTw5o3GXMVyQ8/oOciVznNgQ4Q5pXUdkUmd.png'
  }, {
    title: 'Patio Heating',
    description: 'Extend your outdoor season with radiant heating for your backyard patio.',
    image: 'https://cdn.magicpatterns.com/uploads/vvaGrLwspWMSWW22RjHhLr/VHgDKeydrFzcSwvUY-6b0_86702be9fd9d4e1ca6e2f89febc838eb.png'
  }, {
    title: 'Stairs & Porches',
    description: 'Critical safety areas that are often the most dangerous when icy.',
    image: 'https://cdn.magicpatterns.com/uploads/hy44txh3gZhMyLJRW8FjEZ/bk0dL-kEX48cnXq0-doMf.png'
  }];
  return <section id="services" className="py-16 bg-slate-50 md:py-24" data-id="element-918">
      <div className="container mx-auto px-4 md:px-6" data-id="element-919">
        <div className="max-w-2xl mb-12" data-id="element-920">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-921">
            Complete Outdoor Heating Solutions
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-922">
            We do more than just driveways. Create a complete snow-free zone
            around your entire property.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-923">
          {services.map((service, index) => <Card key={index} className="overflow-hidden group hover:shadow-lg transition-all" data-id="element-924">
              <div className="h-64 bg-slate-200 relative overflow-hidden" data-id="element-925">
                {/* Image or Placeholder */}
                {service.image ? <img src={service.image} alt={service.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-926" /> : <div className="absolute inset-0 flex items-center justify-center bg-slate-300 group-hover:bg-slate-200 transition-colors" data-id="element-927">
                    <span className="text-slate-500 font-medium" data-id="element-928">
                      {service.title} Image
                    </span>
                  </div>}
              </div>
              <CardHeader data-id="element-929">
                <CardTitle data-id="element-930">{service.title}</CardTitle>
              </CardHeader>
              <CardContent data-id="element-931">
                <p className="text-slate-600" data-id="element-932">{service.description}</p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}